const tr = {
  nav: {
    home: 'Ana Sayfa',
    about: 'Hakkımda',
    resume: 'Özgeçmiş',
    principle: 'Çalışma Prensibim',
    contact: 'İletişim',
  },
  hero: {
    firstName: 'Murat',
    lastName: 'Selçukoğlu',
    greeting: 'Merhaba, ben',
    occupation: 'Mobil Frontend Geliştirici',
    from: 'şehrinde yaşıyor',
    description:
      'Gel birlikte yaptıklarıma göz atalım — dijital dünyama hoş geldin.',
    cta: 'Daha fazlası',
    download: 'Özgeçmişi indir',
    scroll: 'Aşağı kaydır',
  },
  about: {
    title: 'Hakkımda',
    bio: 'Adım Murat. Dört yılı aşkın deneyimimle React Native ve React (Next.js) kullanarak mobil ve web uygulamaları geliştiren bir Mobil Frontend Geliştiriciyim. Ölçeklenebilir ve yüksek performanslı kullanıcı arayüzleri tasarlama, RESTful API entegrasyonu ve App Store ile Google Play için uçtan uca yayın süreçleri (dağıtım, güncellemeler ve performans optimizasyonu dahil) konularında uzmanım. Temiz ve okunabilir kod yazmaya, herkes için erişilebilir ve estetik tasarımları dengeleyen arayüzler geliştirmeye odaklanıyorum.',
    contactDetails: 'İletişim Bilgileri',
    downloadResume: 'Özgeçmişi İndir',
    location: 'Konum',
    email: 'E-posta',
    phone: 'Telefon',
  },
  resume: {
    educationTitle: 'Eğitim',
    workTitle: 'Deneyim',
    skillsTitle: 'Yetenekler',
    skillMessage:
      'React Native ve React.js birincil frontend teknolojilerim; bunları derin JavaScript bilgimle tamamlıyorum. App Store ve Google Play üzerinde çok sayıda iOS ve Android uygulaması yayınladım; fikir aşamasından üretim sürümüne kadar tüm yaşam döngüsünü deneyimledim.',
    present: 'Devam ediyor',
    education: [
      {
        school: 'Millî Savunma Üniversitesi — Ankara, Türkiye',
        degree: 'Sistem Mühendisliği Lisans (B.Sc.)',
        graduated: '2009 – 2013',
        description:
          'Sistem mühendisliği, yazılım geliştirme, BT sistemleri ve sistem mimarileri odaklı Sistem Mühendisliği lisans derecesi. ZAB (Almanya Yabancı Eğitim Merkezi) tarafından Alman lisans düzeyinde yükseköğrenim diploması olarak denkliği tanınmıştır.',
      },
    ],
    work: [
      {
        slug: 'akinon',
        company: 'Akinon',
        title: 'Mobil Frontend Geliştirici',
        years: 'Haziran 2023 – Ağustos 2025',
        description:
          'Önde gelen perakende markalarına yönelik e-ticaret uygulamaları geliştiren bir React Native Geliştirici olarak çalıştım. Dünyada türünün ilk örneği olan Türkiye Lacoste uygulamasının geliştirme ve lansman sürecine liderlik ettim; Arap bölgesinde çok popüler olan Lulu Süpermarket uygulamasının geliştirilmesinde de yer aldım. Ayrıca Marks & Spencer, GAP, Koton, Intersport ve Forever21 gibi markaların uygulamalarının hayata geçirilmesinde aktif rol aldım ve şirket bünyesindeki pek çok markanın bakımında görev aldım. Bu projeler; kullanıcı dostu arayüzler oluşturma, güçlü performans sağlama ve çapraz fonksiyonlu ekiplerle etkin işbirliği yapma yeteneklerimi pekiştirdi.',
      },
      {
        slug: 'cyberkoc',
        company: 'CyberKOC (Freelance)',
        title: 'Mobil Frontend Geliştirici',
        years: 'Mart 2024 – Ağustos 2025',
        description:
          'Bir yayınevi için React Native ile geliştirilen "Al Moheet" adlı mobil kitap okuma uygulamasını geliştirdim. App Store ve Google Play yayın süreçleri (dağıtım, güncellemeler ve bakım) tarafımdan yönetildi. Görevlerim arasında uygulama performansının optimizasyonu, yeni özelliklerin geliştirilmesi ve tüm platformlarda akıcı, tutarlı bir kullanıcı deneyimi sağlanması yer aldı.',
      },
      {
        slug: 'yapisepeti',
        company: 'Yapı Sepeti (Freelance)',
        title: 'React Native Geliştirici',
        years: 'Mart 2023 – Temmuz 2023',
        description:
          'Yapı Sepeti mobil uygulamasının React Native ile geliştirilmesinde görev aldım. Kullanıcı arayüzlerinin hayata geçirilmesi, API entegrasyonları, yeni özelliklerin geliştirilmesi ve mevcut özelliklerin optimizasyonundan sorumluydum. Uygulamanın kararlılığını ve performansını artırmak için hata analizleri yaptım ve teknik sorunları giderdim.',
      },
      {
        slug: 'mobrespos',
        company: 'Mobrespos Yazılım',
        title: 'Mobil Frontend Geliştirici',
        years: 'Nisan 2021 – Haziran 2023',
        description:
          'İki yılı aşkın süre boyunca React Native ile mobil uygulamaların geliştirilmesi ve iyileştirilmesi üzerinde çalıştım; konseptten implementasyona, testlerden yayınlama ve bakıma kadar tüm geliştirme döngüsünde yer aldım. Restoran ve dijital sipariş sistemleri için kullanıcı dostu mobil uygulamalar geliştirdim ve optimal kullanıcı deneyimi için modern UI/UX konseptleri uyguladım. Ayrıca React ile web uygulamaları geliştirip bakımını yaptım, RESTful API’ler üzerinden backend servisleri entegre ettim; yeni özellikler, süreç iyileştirmeleri ve uygulamaların farklı platformlardaki performans ve kararlılığı üzerinde çalıştım.',
      },
      {
        slug: 'msb',
        company: 'MSB (Millî Savunma Bakanlığı)',
        title: 'Sistem Mühendisi',
        years: 'Ağustos 2013 – Nisan 2021',
        description:
          'Sistem Mühendisi olarak uzun yıllar teknik sistemlerin analizi, planlanması, uygulanması ve geliştirilmesinden sorumlu oldum. Karmaşık BT ve iletişim altyapılarının yönetiminde kapsamlı deneyim kazandım; donanım ve yazılım sistemlerinin kurulumu, yapılandırılması ve bakımı, sistem analizlerinin yürütülmesi ile teknik sorunların tespiti ve giderilmesi görevlerimi oluşturdu. Ayrıca mevcut sistem mimarilerinin optimizasyonu, sistem kararlılığının iyileştirilmesi, teknik projelerin planlanması ve hayata geçirilmesi ile farklı birimlerle işbirliği içinde teknik dokümantasyon hazırlanması konularında çalıştım.',
      },
    ],
  },
  testimonials: {
    title: 'Çalışma Prensibim',
    subtitle: 'Beni harekete geçiren',
    items: [
      {
        text: 'Sağlam yazılım çözümleri tasarlama ve geliştirme konusunda geniş deneyime sahip, deneyimli bir yazılım geliştiriciyim. Güçlü problem çözme yeteneğim ve titiz test yaklaşımım yetkinliklerimin temelini oluşturuyor. Kariyerim boyunca teknik uzmanlığı detaylara verdiğim önemle birleştirerek sürekli olarak yüksek kaliteli yazılımlar teslim ettim. Dinamik ortamlarda gelişiyor; karmaşık problemleri verimli ve hassas bir şekilde çözüyorum.',
        user: 'Murat SELÇUKOĞLU',
        role: 'Geliştirici Felsefem',
      },
      {
        text: 'Bakımı kolay koda inanıyorum — sade, okunabilir ve sadece gerekli olana indirgenmiş kod. Hızlı teslim önemli; ancak uzun vadede önemli olan, ekibin altı ay sonra da anladığı koddur. Bu yüzden mimariye, kod incelemelerine ve otomatik testlere zaman ayırıyorum.',
        user: 'Murat SELÇUKOĞLU',
        role: 'Kod Kalitesi',
      },
      {
        text: 'Performans bir bonus değil, kullanıcı deneyiminin bir parçasıdır. Bundle boyutunu küçültmekten render optimizasyonuna ve native modüllere kadar; sürekli ölçer, analiz eder ve iyileştiririm — böylece uygulama yalnızca çalışmakla kalmaz, akıcı da hissettirir.',
        user: 'Murat SELÇUKOĞLU',
        role: 'Performans & UX',
      },
    ],
  },
  contact: {
    title: 'İletişime Geç',
    lead: 'Aklında bir proje mi var, yoksa sadece merhaba mı demek istiyorsun? Bana yaz, en kısa sürede dönüş yapayım.',
    name: 'İsim',
    email: 'E-posta',
    subject: 'Konu',
    message: 'Mesaj',
    submit: 'Mesajı Gönder',
    sending: 'Gönderiliyor…',
    success: 'Mesajın başarıyla iletildi. Teşekkür ederim!',
    error: 'Bir hata oluştu. Lütfen tekrar dene.',
    required: 'Zorunlu',
    sidebarTitle: 'Adres & Telefon',
    available: 'Yeni projelere açığım',
  },
  footer: {
    rights: 'Tüm hakları saklıdır.',
    builtWith: 'React ve sevgiyle geliştiren:',
    backToTop: 'Yukarı çık',
  },
};

export default tr;
